import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: spacing(6),
  },
  copyright: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(4),
  },
  logo: {
    width: spacing(16),
    height: spacing(16),
  },
}));

export default stylesheet;
